import type { useSettingsSections } from '@/hooks/useSettingsSections';

export const SETTINGS_SECTIONS = [
  'general',
  'response',
  'ballots',
  'notifications',
  'membership',
  'privacy',
  'account',
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTIONS)[number];

/** Each new object represents an explicit request, including a repeated category. */
export interface SettingsSectionRequest {
  section: SettingsSectionId;
}

export interface SettingsPanelProps {
  settings: ReturnType<typeof useSettingsSections>;
}

export interface SettingsEditState {
  dirty: boolean;
  saving: boolean;
  discard: () => void;
}
